import React, { createContext, useState, useEffect } from "react";
import { authUser } from "../service/authService"; // authUser funksiyası import edilir

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token") // LocalStorage-da token varsa, istifadəçi daxil olub sayılır
  );
  const [loading, setLoading] = useState(true);

  const getUser = async () => {
    const token = localStorage.getItem("token"); // LocalStorage-dan token alınır

    if (token) {
      try {
        const response = await authUser(token); // Token göndərilərək istifadəçi məlumatları alınır
        setUser(response); // İstifadəçi məlumatları kontekstə əlavə edilir
      } catch (e) {
        console.error("User authentication failed", e);
        setIsAuthenticated(false); // Əgər autentifikasiya uğursuz olarsa, çıxış ediləcək
        setUser(null);
      } finally {
        setLoading(false); // Yükləmə bitir
      }
    } else {
      setLoading(false); // Token yoxdursa, loading bitir
    }
  };

  useEffect(() => {
    getUser(); // İstifadəçi məlumatlarını almağa cəhd edilir
  }, [isAuthenticated]); // isAuthenticated dəyişdikdə, getUser yenidən çağırılır

  const login = (token, userData) => {
    localStorage.setItem("token", token); // Token LocalStorage-a saxlanır
    setIsAuthenticated(true); // İstifadəçi daxil olub
    setUser(userData); // İstifadəçi məlumatları saxlanır
  };

  const logout = () => {
    localStorage.removeItem("token"); // Token silinir
    setIsAuthenticated(false); // İstifadəçi çıxış edir
    setUser(null); // İstifadəçi məlumatları sıfırlanır
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        isAuthenticated,
        setIsAuthenticated,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
